import axios from 'axios'
import { apiUrl, isRx4Route } from '@/config'
import { todayAddressToken } from '@/utils/trackingSameDay.mjs'
import { buildAccessQueryParams } from '@/utils/trackAccessAuth'

// Сохраняем capability исходной ссылки при переходах внутри приложения.
const todayToken = isRx4Route ? todayAddressToken(window.location.search) : null

const instance = axios.create({
  baseURL: apiUrl,
})

instance.interceptors.request.use(config => {
  const accessParams = buildAccessQueryParams()
  if (todayToken) {
    accessParams.today_token = todayToken
  }
  if (!Object.keys(accessParams).length) {
    return config
  }

  config.params = {
    ...(config.params || {}),
    ...accessParams,
  }

  return config
})

export default instance
